import { h } from 'preact';
import Page from 'components/pages/page.js';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import Playlist from 'components/shared/playlist/playlist.js';
import Transition from 'components/core/transition/transition';
import { SvgFullScreenOpen, SvgFullScreenClose } from 'components/shared/svgIcons/svgIcons';
import PreloadThumb from 'components/shared/preloadThumb/preloadThumb';
import SimpleVideoPlayer from 'components/shared/simpleVideoPlayer/simpleVideoPlayer';
import s from 'components/pages/gallery/gallery.sss';
import { accessNested, condClass, asList, sortObjectByOrder } from 'utils/utils';
import { useDynamicAssetFolder } from 'utils/assets';
import { Link } from 'components/core/link/link.js';
import { track } from 'utils/tracking';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class Gallery extends Page {

	/**
	 * LifeCycle
	 */
	constructor(props) {
		super(props);
		let { showPlaylist } = props.pageData;
		this.cycle = this.cycle.bind(this);
		this.cycleLeft = this.cycle.bind(this, -1);
		this.cycleRight = this.cycle.bind(this, 1);
		this.cycleLeftWithKeyboard = this.cycleWithKeyboard.bind(this, 'left');
		this.cycleRightWithKeyboard = this.cycleWithKeyboard.bind(this, 'right');

		this.state.isOpen = showPlaylist || !this.props.fullScreenStart;

		this.togglePlaylistCallback = this.togglePlaylistCallback.bind(this);
		this.togglePlaylistWithKeyboard = this.togglePlaylistWithKeyboard.bind(this);
		this.updateVideoSize = this.updateVideoSize.bind(this);
	}

	componentDidMount() {
		this.updateVideoSize();
	}

	componentDidUpdate(prevProps, prevState) {
		this.updateVideoSize();
		if (prevState.activeItem.src !== this.state.activeItem.src) {
			setTimeout(() => this.updateVideoSize(), 520);
		}
	}

	componentWillMount() {
		let stateList = this.updateList();
		this.setState({ activeItem: stateList[0] || {} });
	}

	componentWillUpdate(newProps) {
		if (newProps.pageData.list !== this.props.pageData.list) {
			this.updateList(newProps);
		}
	}


	/**
	 * Data handlers
	 */

	getType(src) {
		if (!src) {
			return undefined;
		}
		let ext = src.split('.').pop();
		if (['mov', 'mp4', 'avi'].indexOf(ext) !== -1) {
			return 'VIDEO';
		}
		if (ext === 'gif') {
			return 'GIF';
		}
		return 'IMAGE';
	}

	updateList(props, state) {
		props = props || this.props;
		state = state || this.state;
		let list = props.pageData.list || [];
		if (!Array.isArray(list)) {
			// Make sure it's an array
			list = sortObjectByOrder(list);
		}
		// remove disabled items
		list = list.filter(e => e);
		let newActiveItem = state.activeItem && list.find(item => item && item.src === state.activeItem.src);
		if (!newActiveItem) newActiveItem = list[0] || {};
		this.setState({ list: list, activeItem: newActiveItem });
		return list;
	}

	/**
	 * Event handlers
	**/

	updateVideoSize() {
		if (!this.$activeVideo || !this.$activeVideo.$video) {
			return;
		}
		let size = this.$activeVideo.$video.getBoundingClientRect();
		if (size.width === this.state.videoWidth && size.height === this.state.videoHeight) {
			return;
		}
		this.setState({
			videoWidth: size.width,
			videoHeight: size.height
		});
	}

	cycle(direction, e) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		if (direction === 'left') {
			direction = -1;
		}
		if (direction === 'right') {
			direction = 1;
		}
		let list = this.state.list || [];
		let currIndex = list.indexOf(this.state.activeItem);
		if (currIndex === -1) {
			return;
		}
		let newIndex = (currIndex + direction) % list.length;
		if (newIndex < 0) {
			newIndex += list.length;
		}
		if (newIndex === currIndex) {
			return;
		}
		track({ a: 'set-slide-' + newIndex });

		Store.emit(actions.GALLERY_VIEW_IMAGE, newIndex + 1);
		if (!this.state.isOpen) {
			Store.emit(actions.GALLERY_VIEW_IMAGE_FULLSCREEN, newIndex + 1);
		}
		this.setState({ activeItem: list[newIndex] });
	}

	cycleWithKeyboard = (direction, e) => {
		if (e.key === 'Enter') {
			this.cycle(direction, e);
		}
	}

	togglePlaylistCallback(e) {
		e.preventDefault();

		let openState = this.state.isOpen ? 'closed' : 'open';
		this.setState({ isOpen: !this.state.isOpen });

		track({ a: `gallery-fullscreen-${openState}` });

		let currIndex = this.state.list.indexOf(this.state.activeItem);
		if (currIndex !== -1 && !this.state.isOpen) {
			Store.emit(actions.GALLERY_VIEW_IMAGE_FULLSCREEN, currIndex + 1);
		}
	}

	togglePlaylistWithKeyboard(e) {
		if (e.key === 'Enter') {
			this.togglePlaylistCallback(e);
		}
	}

	updateActive = (item, e) => {
		e.preventDefault();
		this.setState({ activeItem: item });
		let list = this.state.list;
		let currIndex = list.indexOf(this.state.activeItem);
		if (currIndex !== -1) {
			track({ a: `set-slide-thumb-${currIndex}` });

			Store.emit(actions.GALLERY_VIEW_IMAGE, currIndex + 1);
			if (!this.state.isOpen) {
				Store.emit(actions.GALLERY_VIEW_IMAGE_FULLSCREEN, currIndex + 1);
			}
		}
	}

	/**
	 * Render
	**/

	getExtraContent() { }

	renderButtons() {
		let pageData = this.props.pageData;
		let copy = this.props.appData.copy;
		let { downloadButton, pdfDownload, buttons } = pageData;
		let activeItem = this.state.activeItem;

		let full = [];

		if (downloadButton || activeItem.downloadButton) {
			let downloadSrc = useDynamicAssetFolder(activeItem.srcFull || activeItem.src || '');
			if (pdfDownload) {
				downloadSrc = downloadSrc.replace(/\.(jpe?g|png|gif|bmp)$/, '.pdf');
			}
			let filename = downloadSrc.replace(/^(?:.*\/)?([^/]+)$/, '$1');

			// to change the copy if the asset is a video or a gif
			let type = this.getType(downloadSrc);
			let downloadButtonCopy = type && copy['$GALLERY_DOWNLOAD_' + type] || copy['$GALLERY_DOWNLOAD'];
			let trackId = activeItem.trackId || `download-${filename}`;

			let target = undefined;
			// Target blank overrides download in IOS !
			if (!this.props.client.isIOS) {
				target = '_blank';
			}

			const currIndex = this.state.list.indexOf(activeItem);
			const extraOnClick = () => { Store.emit(actions.GALLERY_DOWNLOAD_IMAGE, currIndex + 1); };
			full.push(
				<Link
					class={s.button + condClass(s.downloadButton)}
					download={filename}
					href={downloadSrc}
					target={target}
					trackId={trackId}
					extraOnClick={currIndex > -1 && extraOnClick}
				>
					{downloadButtonCopy}
				</Link>
			);
		}
		asList(buttons).forEach(btn => {
			if (!btn || !btn.url || !btn.copy) {
				return;
			}
			full.push(
				<Link
					class={s.button + condClass(btn.class && s[btn.class])}
					download
					href={btn.url}
					target="_blank"
				>
					{copy[btn.copy]}
				</Link>
			);
		});
		return full;
	}

	render({ appData, pageData, sideNavActive }, state) {
		const {
			videoLoop = true,
			unmountResetVideoProgress = false,
			overrideHideControls = false,
			transitionDuration = 1000
		} = pageData;
		let list = state.list;
		let imageClass;
		let wrapper;
		let wrapperClass;
		let showInactive = pageData.showInactive;

		if (!list.length) {
			return <div />;
		}

		if (state.isOpen) {
			wrapperClass = s.activeWrapper;
			imageClass = s.image;
			wrapper = s.wrapper;
		} else {
			wrapperClass = s.activeWrapperFull;
			imageClass = s.imageFull;
			wrapper = s.wrapperFull;
		}

		// to deal with the showInactive
		let activeIndex = list.indexOf(this.state.activeItem);

		let name = accessNested(state, 'activeItem.name', '');
		let activeName = name && (appData.copy[name] || (name.charAt(0) !== '$' ? name : ''));
		let alt = accessNested(state, 'activeItem.alt', '') || activeName;
		alt = appData.copy[alt] || alt;
		// Unavailable copy
		if (alt.startsWith('$')) {
			alt = '';
		}
		// Always use a default alt value
		alt = alt || 'Image ' + (activeIndex + 1) + ' of the ' + accessNested(appData, 'meta.title.locale') + ' gallery';
		const thumbAlt = 'Image of the ' + appData.meta.title.locale + ' gallery';
		let device = this.props.client.deviceSize;
		let activeSrc = device === 'mobile' ? (state.activeItem.mobSrc || state.activeItem.src) : state.activeItem.src;
		activeSrc = useDynamicAssetFolder(activeSrc);
		const activeThumbSrc = useDynamicAssetFolder(state.activeItem.thumbSrc);
		let buttons = this.renderButtons();
		if (Array.isArray(buttons) && !buttons.filter(e => e).length) {
			buttons = null;
		}
		let type = this.getType(state.activeItem.src);
		let element = (
			<PreloadThumb
				containerClass={s.preload}
				class={imageClass}
				src={activeSrc}
				thumbSrc={activeThumbSrc}
				depthMap={state.activeItem.depthMap}
				annotation={state.activeItem.annotation}
				alt={alt}
				key={activeSrc}
				onClick={this.togglePlaylistCallback}
				client={this.props.client}
			/>
		);

		let inactiveLeftElement;
		let inactiveRightElement;
		if (showInactive) {
			let prevIndex = activeIndex === 0 ? list.length - 1 : (activeIndex - 1);
			let	nextIndex = activeIndex === list.length - 1 ? 0 : (activeIndex + 1);
			let inactiveLeft = list[prevIndex] || {};
			let inactiveRight = list[nextIndex] || {};
			let leftSrc = inactiveLeft.src || '';
			let rightSrc = inactiveRight.src || '';
			inactiveLeftElement = (
				<div class={s.inactiveLeft} key="inactive-previous">
					<PreloadThumb
						class={s.imageLeft}
						src={(device === 'mobile' && inactiveLeft.mobSrc) || leftSrc}
						alt={alt}
						onClick={this.togglePlaylistCallback}
					/>
				</div>
			);
			inactiveRightElement = (
				<div class={s.inactiveRight} key="inactive-next">
					<PreloadThumb
						class={s.imageRight}
						src={(device === 'mobile' && inactiveRight.mobSrc) || rightSrc}
						alt={alt}
						onClick={this.togglePlaylistCallback}
					/>
				</div>
			);
		}

		if (type === 'VIDEO') {
			let controlsStyle = {};
			if (state.videoWidth) controlsStyle.width = state.videoWidth + 'px';
			if (state.videoHeight) controlsStyle.height = state.videoHeight + 'px';
			element = (
				<SimpleVideoPlayer
					parentClass={s.videoContainer}
					class={imageClass}
					src={state.activeItem.src}
					thumbSrc={state.activeItem.thumbSrc}
					autoplay={!!state.activeItem.src}
					muted
					loop={videoLoop}
					showControls
					controlsContainerStyle={controlsStyle}
					ref={e => (this.$activeVideo = e)}
					canPlayCallback={this.updateVideoSize}
					unmountResetVideoProgress={unmountResetVideoProgress}
					overrideHideControls={overrideHideControls}
				/>
			);
		}

		let ToggleSvgIcon = state.isOpen ? SvgFullScreenOpen : SvgFullScreenClose;

		let activeItemSrc = useDynamicAssetFolder(state.activeItem.src || '');
		let activeItemId = activeItemSrc.replace(/[^a-z0-9_]+/gi, '-').slice(-30).replace(/^[^a-z]+/i, '');

		return (
			<div>
				<div class={wrapper + condClass(sideNavActive, s.sideNavActive) + condClass(state.isOpen, s.isOpen)}>
					<div class={wrapperClass}>
						<span
							class={s.arrow}
							onClick={this.cycleLeft}
							role="button"
							tabindex="0"
							onKeyDown={this.cycleLeftWithKeyboard}
							key="arrow-left"
							tabindex="0"
						/>
						{inactiveLeftElement}
						<Transition
							class={s.transitionContainer}
							visibleClass={s.transition}
							leavingClass={s.transition}
							duration={transitionDuration || 1000}
							key="transition"
						>
							<div id={activeItemId} key={activeItemId}>
								{element}
								{buttons && <div class={s.buttons} key="buttons">{buttons}</div>}
							</div>
						</Transition>
						{inactiveRightElement}
						<span
							class={s.arrow}
							onClick={this.cycleRight}
							key="arrow-right"
							role="button"
							tabindex="0"
							onKeyDown={this.cycleRightWithKeyboard}
						/>
						<div
							class={s.toggleActive}
							onClick={this.togglePlaylistCallback}
							key="toggle"
							role="button"
							tabindex="0"
							onKeyDown={this.togglePlaylistWithKeyboard}
						>
							<ToggleSvgIcon class={s.fullScreenSvg} />
						</div>
					</div>
					<Playlist
						key="galleryPlaylist"
						list={list}
						playlistId="gallery"
						copy={appData.copy}
						onPlaylistItemClick={this.updateActive}
						playlistClass={state.isOpen ? s.openPlaylist : s.hiddenPlaylist}
						showButtons
						activeItem={state.activeItem}
						alt={thumbAlt}
					/>
				</div>
				{this.getExtraContent()}
			</div>
		);
	}

}
